import fetchExpresso from 'utility/fetchExpresso';

export async function getIncidentalTypes() {
    try {
        const response = await fetchExpresso(`/apiv2/incidental_types/`);

        if (response.status === 200) {
            const data = await response.json();

            const types = data.types
                .filter((i) => [2, 3, 999].includes(i.inc_type_id))
                .map((t) => ({ id: t.inc_type_id, name: t.type_name })); // Rename fields

            return types;
        } else {
            const data = await response.json();
            throw new Error(`[${response.status}] ${data.message}`);
        }
    } catch (e) {
        throw e;
    }
}

export async function getIncidentalsForEvent(id, limitTypes) {
    try {
        const response = await fetchExpresso(`/apiv2/events/${id}/incidentals/`);

        if (response.status === 200) {
            const data = await response.json();

            const incidentalsEnabled = data.incidentalsEnabled;

            let incidentals = data.incidentals.map((i) => ({
                id: i.inc_id,
                type: i.type_name,
                typeId: i.inc_type_id,
                status: i.inc_status_id,
                desc: i.inc_desc,
                subtotal: i.sub_total,
                tax: i.tax_total,
                total: i.total,
                when: i.created_at,
            }));

            if (Array.isArray(limitTypes)) {
                // Caller requested only specific types by passing in an array of IDs
                incidentals = incidentals.filter((i) => limitTypes.includes(i.typeId));
            }

            return { incidentalsEnabled, incidentals };
        } else {
            const data = await response.json();
            throw new Error(`[${response.status}] ${data.message}`);
        }
    } catch (e) {
        throw e;
    }
}

export async function createIncidental(eventId, params) {
    try {
        const response = await fetchExpresso(`/apiv2/events/${eventId}/incidentals/`, {
            method: 'POST',
            body: {
                type: params.type,
                description: params.description,
                subtotal: params.subtotal,
                tax: params.tax,
                total: params.total,
            },
        });

        if (response.status === 200) {
            return null;
        } else {
            const data = await response.json();
            throw new Error(`[${response.status}] ${data.message}`);
        }
    } catch (e) {
        throw e;
    }
}

export async function deleteIncidental(incId, eventId) {
    try {
        const response = await fetchExpresso(`/apiv2/events/${eventId}/incidentals/${incId}`, {
            method: 'DELETE',
        });

        if (response.status === 200) {
            return null;
        } else {
            const data = await response.json();
            throw new Error(`[${response.status}] ${data.message}`);
        }
    } catch (e) {
        throw e;
    }
}

export async function collectIncidental(incId, eventId) {
    try {
        const response = await fetchExpresso(
            `/apiv2/events/${eventId}/incidentals/${incId}/collect`,
            {
                method: 'PUT',
            },
        );

        if (response.status === 200) {
            return null;
        } else {
            const data = await response.json();
            throw new Error(`[${response.status}] ${data.message}`);
        }
    } catch (e) {
        throw e;
    }
}
